import React, { useCallback, useEffect, useState } from 'react';
import '../../Assets/Styles/offCanvas.css';
import { cartAddServiceTimeslot, checkValidCart, confirmBooking, getMyProfileDetails, getSearchFilter, serviceTimeSlotDetails, userSelectSearchLocation } from '../../Services/api';
import { useNavigate, useParams } from 'react-router-dom';
//firebase
import { getDatabase, ref, set, onValue } from "firebase/database";
import database from '../../Services/firebase-service/firebase';
import ReactLoading from 'react-loading';
import useRazorpay from "react-razorpay";
import axiosInstance from '../../Services/axios';
import OfferCard from '../../Pages/Offers/offercard';
import { toast } from 'react-toastify';
import MembershipCard from '../MembershipCard/MembershipCard';
import Lottie from "lottie-react";
import empotyLottie from "../../Assets/lottieFiles/emptybox.json"
import { FaArrowLeftLong } from "react-icons/fa6";
import VoiceSearchInput from '../VoiceSearchInput/VoiceSearchInput';
import VendorCategorieList from '../vendorcategories/vendorCategorieList';
import { CardText } from 'react-bootstrap';
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import { showToast } from '../toastConfig/ToastConfig';
import NodeaxiosInstance from '../../Services/nodeaxios';


const MembershipSearch = ({ Membership_from_Page }) => {

    const navigate = useNavigate();
    const [searchData, setSearchData] = useState("");
    const [membershipDetailData, setMembershipDetailData] = useState([]);
    const [merchantServiceId, setMerchantServiceId] = useState(0);
    const [latlong, setLatLong] = useState("");
    const [serviceTypeFilterData, setServiceTypeFilterData] = useState([])
    const [citySelectedVal, setCitySelectedVal] = useState("");
    const [apiSearchingDataLoader, setApiSearchingDataLoader] = useState(true);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [inputSearchValue, setInputSearchValue] = useState("");
    const [showSearch, setShowsearch] = useState(false)
    const [categorieData, setCategorieData] = useState({
        vendor_type_id: null,
        vendor_category_id: null,
        vendor_type_name: "",
        vendor_category_name: "",
    });

    useEffect(() => {
        getFilterData()
    }, []);

    useEffect(() => {
        // API requires user location; wait until it is loaded
        if (!latlong) return;
        getMembershipDetails()
    }, [latlong, merchantServiceId, searchData, categorieData, inputSearchValue])

    const getFilterData = async () => {
        try {
            const [response, locationRes] = await Promise.all([getSearchFilter(), userSelectSearchLocation()]);
            if (response?.status == 200) {
                const data = response?.data
                const selectedLocation = locationRes?.data?.selected_location
                setServiceTypeFilterData(data?.vendor_type || [])
                setLatLong(selectedLocation?.latlng || "")
                setCitySelectedVal(selectedLocation?.address || "");
                setPageLoaded(true)
                setApiSearchingDataLoader(true)
                // getOfferDetails()
                // setRecentSecarchOnOFF(false)

            }
        } catch (err) {
            console.error("getFilterData failed:", err);
            const status = err?.response?.status;
            if (!err?.response || status == 400 || status == 500) {
                showToast(err?.response?.data?.message || "Something went wrong, please try again later", "error");
            }
        }
    }

    const getMembershipDetails = async () => {
        try {
            let params = {
                user_location: latlong,
                search_name: inputSearchValue,
                search_type: categorieData?.vendor_type_id || 0,
                search_category: ''
            }
            const response = await NodeaxiosInstance.post('/search-membership', params)
            const data = await response
            setMembershipDetailData(response?.data?.search_results || [])
            setPageLoaded(true)
        } catch (err) {
            const status = err?.response?.status;
            if (!err?.response || status == 400 || status == 500) {
                showToast(err?.response?.data?.message || "Something went wrong, please try again later", "error");
            }
        }
    }

    const dateOptions = { year: 'numeric', month: 'short', day: 'numeric' };

    // let renderOfferCardItem = ({ item, index }) => {
    //     return (<>
    //         <Pressable onPress={() => {
    //             navigation.navigate("ViewOfferDetails",
    //                 {
    //                     applied_to_status: item?.applied_to_status,
    //                     vendor_id: item?.vendor_id,
    //                     offer_id: item?.offer_id
    //                 })
    //         }}>
    //             <View style={{ marginTop: 10, paddingVertical: 10, marginHorizontal: 10 }}>
    //                 <View style={[styles.firstCard, { borderRadius: 10, flex: 1, flexDirection: 'row', zIndex: 111, backgroundColor: "#fff", }]}>
    //                     <View style={{ width: 105, height: 148 }}>
    //                         <Image source={{ uri: item?.offers_image }} style={{ height: "100%", width: "100%", resizeMode: "contain", borderRadius: 10 }}></Image>
    //                     </View>
    //                     <View style={{ width: screenWidth - 150, paddingHorizontal: 10 }}>
    //                         <Text style={{ fontSize: 16, fontFamily: FontFamily.poppinsSemibold, color: "#000a", lineHeight: 20, marginRight: 30 }}>{item?.offer_name}</Text>
    //                         {
    //                             item.offer_type == 3 ? <Text style={{ fontSize: 12, fontFamily: FontFamily.poppinsMedium, color: PRIMARY_BACKGROUND }}>
    //                                 Buy Get Offer
    //                             </Text> : <Text style={{ fontSize: 12, fontFamily: FontFamily.poppinsMedium, color: PRIMARY_BACKGROUND }}>
    //                                 Get {item?.discount_amount}
    //                                 <Text style={{ fontFamily: "arial" }}>{Number(item?.discount_type) == 1 ? "₹ " : Number(item?.discount_type) == 2 ? "% " : ''}</Text>
    //                                 Offer
    //                             </Text>
    //                         }
    //                         <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'baseline' }}>
    //                             <Text style={{ fontSize: 16, fontFamily: FontFamily.poppinsSemibold, color: PRIMARY_BACKGROUND, lineHeight: 20 }}>{item?.vendor_company_name}</Text>
    //                             <View style={{ flexDirection: 'row', }}>
    //                                 <Ionicons name="location-sharp" size={11} color={PRIMARY_BACKGROUND} style={{ marginLeft: 5, marginTop: -2 }} />
    //                                 <Text style={{ fontSize: 10, fontFamily: FontFamily.poppinsRegular, color: PRIMARY_BACKGROUND, lineHeight: 12 }}>{item?.distance} Km</Text>
    //                             </View>
    //                         </View>
    //                         <View style={{ width: "100%", height: 1, backgroundColor: "#0002", marginVertical: 2 }}></View>
    //                         <Text style={{ fontSize: 10, fontFamily: FontFamily.poppinsRegular, color: "#000", marginTop: 5 }}>{item?.offer_description ? (item?.offer_description?.length > 100 ? item?.offer_description?.substring(0, 100) + "..." : item?.offer_description) : "Your offer discription will be here. "}</Text>
    //                         {/* {
    //                             item.offer_type == 2 ?
    //                                 <>
    //                                     <Text style={{ fontSize: 16, fontFamily: FontFamily.poppinsSemibold, color: PRIMARY_BACKGROUND, lineHeight: 18 }}>Rs.{item?.applied_to.includes('1') ? serviceCost.totalPrice.toFixed(2) : productsCost.totalPrice.toFixed(2)}</Text>
    //                                     <Text style={{ fontSize: 10, fontFamily: FontFamily.poppinsRegular, color: "#000", lineHeight: 12 }}>Actual Cost : <Text style={{ textDecorationLine: 'line-through', textDecorationColor: '#f00' }}>{item?.applied_to.includes('1') ? serviceCost.subTotal.toFixed(2) : productsCost.subTotal.toFixed(2)}</Text>/-</Text>
    //                                 </> : <></>
    //                         } */}
    //                         <View style={{ flexDirection: 'row', justifyContent: 'space-between', position: 'absolute', bottom: 0, left: 10, width: '100%' }}>
    //                             <Text style={{ fontSize: 10, fontFamily: FontFamily.poppinsRegular, color: PRIMARY_BACKGROUND, lineHeight: 12 }}>Expire Date : {new Date(item?.duration).toLocaleDateString('en-US', dateOptions)}</Text>
    //                         </View>
    //                     </View>
    //                 </View>
    //             </View>
    //         </Pressable>
    //     </>)
    // }


    return (

        <div className='searchModal bg-white  '>
            <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white">
                <div className="d-flex justify-content-between align-items-center ms-2 me-2">
                    <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button"
                        onClick={() => navigate(-1)} />

                    <div className="ff-balooPaaji2-bold fs-20 ms-1 ps-1">
                        Memberships
                    </div>
                </div>

            </div>
            <div className='px-3 pt-2'>
                {/* <input type="search" className="ff-poppins-semiBold fs-16 w-100" placeholder="Search Membership" onChange={(event) => {setSearchData(event.target.value)}}/>*/}
                <div className="">
                    <div onClick={() => setShowsearch(true)}>
                        <VoiceSearchInput
                            value={inputSearchValue}
                            setInputSearchValue={setInputSearchValue}
                            fromPage="memberships"
                        />
                    </div>

                </div>
                <div className='bg-white'>
                    <VendorCategorieList setCategorieData={setCategorieData} fromPage={'memberShipSearch'} />
                </div>

                <div className='scroller-style-y ' >
                    <div style={{ marginBottom: "265px" }}>
                        {membershipDetailData && membershipDetailData.length > 0 ? membershipDetailData.map((membership, index) => {

                            return (
                                <div onClick={() => {
                                    navigate(`/MemberShipDetails/${membership.vendor_id}/${membership.membership_id}`,
                                        {
                                            state: {
                                                vendorId: membership.vendor_id, membership_ID: membership.membership_id,
                                                from_Page: "search_page"
                                            }
                                        });
                                }}   >
                                    <MembershipCard
                                        buttonName="Buy Now"
                                        icon
                                        cardColor={membership.card_color}
                                        data={{
                                            membershipDetails: membership,
                                            VendorDetails: { vendor_company_name: membership.vendor_company_name },
                                        }}
                                        Membership_from_Page="search_page"
                                    />
                                </div>
                            )
                        }) :
                            <div>
                                <Lottie animationData={empotyLottie} />
                                <div className='d-flex justify-content-center fs-12 ff-poppins-regular text-dark'>No Membership Available</div>
                            </div>
                        }
                    </div>
                </div>
            </div>

        </div>
    )
};

export default MembershipSearch;









// className={`d-flex justify-content-center align-items-center ff-poppins-medium fs-12 border-0 position-absolute
//     ${offertype === "4" && selectedCartServiceCount >= cardDetail?.combo_count && !subItem.isSelected ? "bg-secondary text-white" :
//      subItem.isSelected ? "primary-bg text-white" : "bg-white primary-text"}`}